export const DIRECT_LINK_APP_CODES = [
  'dashboards',
  'forms',
  'process_design',
  'unibox',
  'data_enrichment',
  'meeting_router',
  'vibe_coder',
  'code_reviewer',
  'mobile_app',
  'landing_page',
  '2_d_games_builder',
  '3_d_games_builder',
  'vibe_video',
  'ai_meeting_notetaker',
  'business_phone',
  'business_receptionist',
  'developer_center',
  // 'digital_employees',
  'ai_qa',
  'ecommerce_marketing',
  'invoices',
  'products',
  'approvals',
];

export const isDirectLinkApp = (appCode, hasExternalUrl = false) => {
  return DIRECT_LINK_APP_CODES.includes(appCode) || hasExternalUrl;
};

